import { UNSUPPORTED_BANKS } from '@pages/clients/AddContactForm/constants';

export const isUnsupportedClabe = (clabe?: string): boolean => {
  if (!clabe) return false;

  return UNSUPPORTED_BANKS.some((bank) => clabe.startsWith(bank.code));
};

export const getUnsupportedBankInfo = (clabe?: string) => {
  if (!clabe) return null;

  return UNSUPPORTED_BANKS.find((bank) => clabe.startsWith(bank.code)) || null;
};
